export enum LayoutHeader {
  shown,
  hidden,
}

export enum LayoutFooter {
  shown,
  hidden,
}
